<template lang='pug'>
span
  BotPageTitle
  h3(:style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }" style='margin-top: 0; margin-bottom: 20px; padding: 0 15px;')
    | {{ $t("drawer.units.subitems.webChannel") }}
  template(v-if='generalConfig')
    .md-layout
      v-row(no-gutters)
        v-col(cols='auto' style='margin: 12px;')
          v-chip-group(id='chip-group' v-model='selectedProfile' mandatory show-arrows)
            v-chip(v-for='(profile, i) in generalConfig.webclientChannels' :key='i' @click='chipChange(i)' filter style='background-color: #ff9800; border-color: #ff9800; color: white!important; transition: 0.5s')
              | {{ profile.name }}
              v-icon.profile-edit-icon(@click='triggerEditing(i)') mdi-square-edit-outline
    CanalWebSinglePage(:canalWebData='generalConfig.webclientChannels[selectedProfile].config' :canalWebId='generalConfig.webclientChannels[selectedProfile].id')
    .md-layout
      v-row(no-gutters style='justify-content: center')
        v-col(cols='auto' style='margin: 12px')
          //- md-button.md-twitter(@click='duplicateData()' style='display: block; margin-left: auto; margin-right: auto;')
          //-   span(style='color: black') {{ $t("commonWords.duplicate") }}
        v-col(cols='auto' style='margin: 12px')
          md-button.md-success(@click='saveData(selectedProfile, "save"); modified = false' style='display: block; margin-left: auto; margin-right: auto;')
            span(style='color: black') {{ $t("commonWords.save") }}
        //- v-col(cols='auto' style='margin: 12px')
        //-   md-button.md-danger(@click='deleteData()' style='display: block; margin-left: auto; margin-right: auto;')
        //-     span(style='color: black') {{ $t("commonWords.exclude") }}
    v-dialog(v-model='saveDataDialog' max-width='500px' @click:outside.stop='saveActionDialog("cancel")')
      v-card
        v-card-title.headline(v-if='oldSelectedProfile !== null') {{$t("webChannel.saveChanges")}} "{{ generalConfig.webclientChannels[oldSelectedProfile].name }}?"
        v-card-actions
          md-button.md-simple(@click='saveActionDialog("cancel")' style='margin: 0px;')
            span {{ $t("commonWords.cancel") }}
          v-spacer
          md-button.md-danger(@click='saveActionDialog("dont-save")' style='margin: 12px;')
            span {{ $t("commonWords.dontSave") }}
          md-button.md-success(@click='saveActionDialog("save")' style='margin: 12px;')
            span {{ $t("commonWords.save") }}
  v-fade-transition
    v-overlay(:value='loading')
      v-progress-circular(style='display: inline-block; width: 100%;' indeterminate size='64')
      .h2.font-weight-thin(style='display: inline-block; width: 100%; height: 100%;')
        | {{$t('canalWeb.loadingSettings')}}
</template>

<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
import CanalWebSinglePage from '@/components/Settings/CanalWeb/CanalWebSinglePage'
import Swal from 'sweetalert2'
import { mapFields } from 'vuex-map-fields'

export default {
  components: { BotPageTitle, CanalWebSinglePage },

  watch: {
    selectedProfile (nV, oV) {
      this.oldSelectedProfile = oV
    }
  },

  computed: {
    ...mapFields('webChannel', ['modified']),
    ...mapFields('selectedAssistant', ['assistantId']),
    idleWarningMessage () {
      return (this.generalConfig.webclientChannels[this.selectedProfile].config.isExpirationWaringActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config.idleWarningMessage.length === 0) ||
        (this.generalConfig.webclientChannels[this.selectedProfile].config.isWebChannelExit === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config.reappearWebChannel <= 0)
    },

    idleTerminationMessage () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.isTerminationActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config.idleTerminationMessage.length === 0
    },

    missingIdleTerminationTime () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.isTerminationActive === true &&
      this.generalConfig.webclientChannels[this.selectedProfile].config.customerIdleTerminationSeconds <= 0
    },

    missingIdleWarningTime () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.isExpirationWaringActive === true &&
        this.generalConfig.webclientChannels[this.selectedProfile].config.customerIdleWarningSeconds <= 0
    },

    invalidIdleTerminationAndWarningTime () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.isTerminationActive &&
          this.generalConfig.webclientChannels[this.selectedProfile].config.isExpirationWaringActive &&
          parseInt(this.generalConfig.webclientChannels[this.selectedProfile].config.customerIdleWarningSeconds) + 10 >
            parseInt(this.generalConfig.webclientChannels[this.selectedProfile].config.customerIdleTerminationSeconds)
    },

    idleTerminationTime () {
      return this.missingIdleTerminationTime || this.invalidIdleTerminationAndWarningTime
    },

    idleWarningTime () {
      return this.missingIdleWarningTime || this.invalidIdleTerminationAndWarningTime
    },

    maximunWordsValidationMessage () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.maximunWords === 0 ||
      this.generalConfig.webclientChannels[this.selectedProfile].config.maximunWords > 50 ||
      this.generalConfig.webclientChannels[this.selectedProfile].config.maximunWords <= 0
    },
    minimumIncidencesValidationMessage () {
      return this.generalConfig.webclientChannels[this.selectedProfile].config.minimumIncidences === 0 ||
      this.generalConfig.webclientChannels[this.selectedProfile].config.minimumIncidences < 3
    }
    // // Criando função que valida select
    // selectedSondValidation () {
    //   return this.generalConfig.webclientChannels[this.selectedProfile].config.selectSound === 0 ||
    //   this.generalConfig.webclientChannels[this.selectedProfile].config.minimumIncidences < 3
    // }

  },

  data () {
    return {
      loading: true,
      selectedProfile: 0,
      oldSelectedProfile: null,
      saveDataDialog: false,
      canalWebBackUp: {},
      chipGpKey: 0,
      generalConfig: null
    }
  },
  methods: {
    async triggerEditing (index) {
      this.$nextTick(async () => {
        if (!this.modified) {
          const { value: text } = await Swal.fire({
            title: this.$t('canalWeb.changeNameProfile'),
            input: this.$t('canalWeb.text'),
            inputValue: this.generalConfig.webclientChannels[index].name,
            inputPlaceholder: this.$t('canalWeb.enterProfileName'),
            inputValidator: (value) => {
              if (!value) {
                return this.$t('canalWeb.pleaseFillFieldAbove')
              }
            }
          })
          if (text) {
            this.generalConfig.webclientChannels[index].name = text
            await this.saveData(this.selectedProfile, 'save')
          }
        }
      })
    },

    chipChange () {
      if (this.modified) {
        this.saveDataDialog = true
      } else {
        setTimeout(() => {
          this.modified = false
          this.updateBackup()
        }, 5)
      }
    },

    async saveActionDialog (type) {
      if (type === 'cancel') {
        let aux = this.selectedProfile
        this.selectedProfile = this.oldSelectedProfile
        this.oldSelectedProfile = aux
      } else if (type === 'dont-save') {
        Swal.fire({
          icon: 'error',
          title: this.$t('canalWeb.changesWereNotSaved')
        })
        this.generalConfig.webclientChannels[this.oldSelectedProfile] = this.canalWebBackUp
        this.updateBackup()
        this.modified = false
      } else if (type === 'save') {
        await this.saveData(this.selectedProfile, 'save')
        this.modified = false
        Swal.fire({
          icon: 'success',
          title: this.$t('canalWeb.changesHaveBeenSaved')
        })
        this.updateBackup()
      }
      this.saveDataDialog = false
    },

    updateBackup () {
      this.canalWebBackUp = JSON.parse(JSON.stringify(this.generalConfig.webclientChannels[this.selectedProfile]))
    },

    requiredFieldsError () {
      Swal.fire({
        icon: 'error',
        title: this.$t('canalWeb.fillMandatoryFields')
      })
    },

    async saveData (index, type) {
      let save = true
      // id dos itens do array removidos/alterados
      if (type === 'save') {
        if (this.idleWarningMessage || this.idleTerminationMessage || this.idleTerminationTime ||
        this.idleWarningTime || this.maximunWordsValidationMessage || this.minimumIncidencesValidationMessage) {
          this.requiredFieldsError()
          save = false
        } else {
          this.loading = true
          this.deletedConfigID = null
          this.savedConfigID = this.generalConfig.webclientChannels[index].id
        }
      } else if (type === 'delete') {
        this.loading = true
        this.savedConfigID = null
        this.deletedConfigID = this.generalConfig.webclientChannels[index].id
        this.generalConfig.webclientChannels.splice(index, 1)
        this.generalConfig.webclientChannels = [...this.generalConfig.webclientChannels]
      }
      var domains = this.generalConfig?.webclientChannels[0]?.config?.domains

      if (typeof this.generalConfig?.webclientChannels[0]?.config?.domains === 'string') {
        domains = domains.split('\n')
      }
      this.generalConfig.webclientChannels[0].config.domains = domains

      var stopWords = this.generalConfig?.webclientChannels[0]?.config?.stopWords

      if (typeof this.generalConfig?.webclientChannels[0]?.config?.stopWords === 'string') {
        stopWords = stopWords.split('\n')
      }
      this.generalConfig.webclientChannels[0].config.stopWords = stopWords

      var userExitControlMessageList = this.generalConfig?.webclientChannels[0]?.config?.userExitControlMessageList
      if (typeof this.generalConfig?.webclientChannels[0]?.config?.userExitControlMessageList === 'string') {
        userExitControlMessageList = userExitControlMessageList.split('\n')
      }
      this.generalConfig.webclientChannels[0].config.userExitControlMessageList = userExitControlMessageList

      if (save) {
        await this.$axios.put(`/assistant-configs/${this.assistantId}`, this.generalConfig)
          .then(() => {
            this.loading = false
            this.$vuetify.goTo(0)
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: this.$t('canalWeb.error'),
              html: `${this.$t('canalWeb.unableToSaveWizardSettings')} <br> ${error}`
            })
          })
      }
    },

    async duplicateData () {
      const { value: text } = await Swal.fire({
        title: this.$t('canalWeb.duplicateThisProfile'),
        text: this.$t('canalWeb.toDuplicateThisProfile'),
        input: this.$t('canalWeb.text'),
        inputValue: this.generalConfig.webclientChannels[this.selectedProfile].name + this.$t('canalWeb.copy'),
        inputPlaceholder: this.$t('canalWeb.enterNameNewProfile'),
        showCancelButton: true,
        confirmButtonText: this.$t('canalWeb.create'),
        cancelButtonText: this.$t('canalWeb.cancel'),
        confirmButtonColor: '#4caf50',
        inputValidator: (value) => {
          if (!value) {
            return this.$t('canalWeb.pleaseFillFieldAbove')
          }
        }
      })

      if (text) {
        const originalIndex = this.selectedProfile
        const copy = JSON.parse(JSON.stringify(this.generalConfig.webclientChannels[originalIndex]))
        copy.name = text
        this.generalConfig.webclientChannels.push(copy)
        const lastIndex = this.generalConfig.webclientChannels.length - 1
        await this.saveData(lastIndex, 'save')

        this.selectedProfile = lastIndex

        this.chipChange()
      }
    },

    async deleteData () {
      const that = this
      const { value: text } = await Swal.fire({
        title: this.$t('canalWeb.doYouWantDeleteProfile'),
        text: `${this.$t('canalWeb.ifYouDeleteThisProfile')} "${that.generalConfig.webclientChannels[that.selectedProfile].name}" ${this.$t('canalWeb.clickConfirm')}`,
        input: this.$t('canalWeb.text'),
        inputPlaceholder: this.$t('canalWeb.enterProfileNameToDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('canalWeb.remove'),
        cancelButtonText: this.$t('canalWeb.cancel'),
        confirmButtonColor: '#ff5252',
        inputValidator: (value) => {
          if (value !== that.generalConfig.webclientChannels[that.selectedProfile].name) {
            return this.$t('canalWeb.pleaseFillFieldAboveCorrectly')
          }
        }
      })

      if (text) {
        const deleteIndex = this.selectedProfile
        this.selectedProfile = 0
        setTimeout(async () => {
          this.modified = false
          await this.saveData(deleteIndex, 'delete')
        }, 500)
        this.chipChange()
        this.$forceUpdate()
      }
    }
  },

  created () {
    if (typeof this.assistantId === typeof null) {
      Swal.fire({
        text: this.$t('canalWeb.pleaseSelectCognitiveAssistant'),
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      this.$router.push('/lista-assistentes')
    }
    if (!this.generalConfig.webclientChannels[0].config.selectSound) {
      this.generalConfig.webclientChannels[0].config.selectSound = this.generalConfig.webclientChannels[0].config.notificationSounds[0]
    }
  },

  async mounted () {
    if (typeof this.assistantId !== typeof null) {
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          this.generalConfig = response.data
          this.updateBackup()
          this.oldSelectedProfile = 0
          // Verifica se input do stopword está vazio e adiciona valor default caso verdadeiro
          if (!this.generalConfig.webclientChannels[0].config.maximunWords) {
            this.generalConfig.webclientChannels[0].config.maximunWords = 50
          }
          if (!this.generalConfig.webclientChannels[0].config.minimumIncidences) {
            this.generalConfig.webclientChannels[0].config.minimumIncidences = 3
          }
          // Verifica se existe audio default se não ele atribui um
          if (!this.generalConfig.webclientChannels[0].config.selectSound) {
            this.generalConfig.webclientChannels[0].config.selectSound = this.generalConfig.webclientChannels[0].config.notificationSounds[0]
          }
          // this.generalConfig.webclientChannels[0].config.notificationSounds[0]
          // this.generalConfig.webclientChannels[0].config.isCustomizedAvatarButton = false
          // this.generalConfig.webclientChannels[0].config.avatarButtonImage = 'https://tmp-omni-misc.s3.us-east-2.amazonaws.com/yara/avatarBot.png',
          // this.generalConfig.webclientChannels[0].config.avatar = 'https://tmp-omni-misc.s3.us-east-2.amazonaws.com/yara/avatarBot.png'
          try {
            this.$axios.put(`/assistant-configs/${this.assistantId}`, this.generalConfig)
          } catch (error) {
            alert(error)
          }
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: this.$t('canalWeb.error'),
            html: `${this.$t('canalWeb.couldNotAccessWizardSettings')} <br> ${error}`
          })
        })
      this.loading = false
    }
  }
}
</script>

<style>
#chip-group .v-chip__content > .v-icon.v-icon--left{
  font-size: 12px !important;
}

.profile-edit-icon {
  transition: 0.5s;
  font-size: 0px !important;
  color: rgba(0,0,0,.54) !important;
}

#chip-group .v-chip:hover .profile-edit-icon {
  font-size: 18px !important;
  margin: 4px;
}
</style>
